import React, { useEffect } from 'react';
import { Col, Row, Container } from 'react-bootstrap';

import PageWrapper from '../components/PageWrapper';
import CallHighlights from './components/CallHighlights';
import ScrollToTop from '../components/ScrollToTop';
import csioCertified from '../../assets/images/leadersForStandardsAndSolutions/csioCertifiedEDocsBilling.png';
import theRoadToRobustDataStandards from '../../assets/images/leadersForStandardsAndSolutions/theRoadToRobustDataStandards.png';
// import AdvisoryCommittee from './components/AdvisoryCommittee';
import CLDataStandardsHighlights from './components/CLDataStandardsHighlights';
// import commercialLinesCertificationProgram from '../../assets/images/leadersForStandardsAndSolutions/commercialLinesCertificationProgram.png';
import DataStandardsHighlights from './components/DataStandardsHighlights';
import CSIO_2021_Annual_Report_CL_Working_Groups from '../../assets/CSIO_2021_Annual_Report_CL_Working_Groups.pdf';
import CSIO_2021_Annual_Report_National_Standards_working_group from '../../assets/CSIO_2021_Annual_Report_National_Standards_working_group.pdf';

// import chatBubble2 from '../../assets/images/leadersForStandardsAndSolutions/chatBubble2.png';
// import chatBubble3 from '../../assets/images/leadersForStandardsAndSolutions/chatBubble3.png';

const InnovationPage = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  const videoPlayerWidth = (width > MAX_WIDTH ? MAX_WIDTH : width) / 2;
  const videoPlayerHeight = videoPlayerWidth * .618;

  useEffect(() => {
    // window.scrollTo(0, 0);
  }, []);

  return (
    <PageWrapper height={height} showHeaderLogo isMobile={isMobile}>
      <Row>
        <Col>
          <h2 style={{ marginTop: 120 }}>
            <span style={{ color: '#00546F' }}>LEADERS FOR</span> STANDARDS AND SOLUTIONS
          </h2>
          <p style={{ marginTop: 30 }} class="greenP">
            CSIO members look to us first for Data Standards and technology solutions. We continue
            to lead the evolution of Standards and solutions by bringing the Canadian Property and
            Casualty (P&C) industry together for consensus on the language and data we’re all going
            to use.
          </p>
          <p class="greenP">
            In 2021, we reached important milestones in eliminating a slow and unwieldy process
            for answering customers’ billing and claims questions by leveraging established industry
            infrastructure.
          </p>
          <p class="greenP">
            We continued to help set brokers up for commercial client success, adding Data Standards
            for a new sector: multi-operations small business.
          </p>
          <p class="greenP">
            We’re proud to bring Members, Committees and Working Groups together to ease these
            and other pain points that are barriers to business.
          </p>
          <h3 style={{ marginTop: 60, textAlign: 'center' }} id="innotech-and-emerging-technology" tabIndex="-1">
            INNOVATION AND EMERGING TECHNOLOGY
            (INNOTECH) BILLING & CLAIMS <span style={{ textTransform: 'lowercase' }}>e</span>DOCS NOTIFICATIONS
          </h3>
          <p style={{ marginTop: 30 }}>
            2021 heralded a giant step forward in data exchange between brokers and insurers.
          </p>
          <p>
            Until recently, brokers were devoting hours each day to chasing answers to customer claims status
            and billing questions.
          </p>
          <CallHighlights />
          <p style={{}}>
            The INNOTECH Committee and Working Groups solved the problem using the CSIO eDocs Standard
            and CSIOnet—two solutions that major insurers and tens of thousands of brokers have integrated
            seamlessly into their daily operations.
          </p>
          <h4 style={{ color: '#48604C', marginTop: 60 }}>
            Welcome to the next generation of eDOCS
          </h4>
          <p style={{ marginTop: 30 }}>
            Now, rather than a manual and time-intensive response to customer inquiries, brokers have the
            answers customers need right in their broker management system (BMS).
          </p>
          <p>
            The new notification solution allows insurers to proactively deliver customer updates to brokers’ BMS.
            The information travels as an eDoc through CSIOnet.
          </p>
          <p>
            The real-time connection enables instant transactions, supporting the digitization of insurance
            operations.
          </p>
          <h5 className='benefitsAtAGlance' style={{ marginTop: 30 }}>
            Benefits at a glance
          </h5>
          <ul>
            <li class="keyBenefits">
              Key billing and claims details are electronically uploaded in the BMS client file
            </li>
            <li class="keyBenefits">
              Seamless, real-time exchange of data
            </li>
            <li class="keyBenefits">
              Savings in time and money
            </li>
            <li class="keyBenefits">
              Less time waiting for information, more time with customers
            </li>
            <li class="keyBenefits">
              Paper reduction
            </li>
          </ul>
          <h6 style={{ color: "#1B526D", marginTop: 30 }}>
            Taking the next step: Certification
          </h6>
          <p>
            We also introduced a Billing & Claims eDocs Certification Program for insurers and vendors in 2021.
          </p>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            marginTop: 30
          }}>
            <img
              src={csioCertified}
              height="200px"
              width="200px"
              alt="CSIO certified eDocs billing medal"
            />
            <div style={{
              marginLeft: 30,
              marginTop: 30
            }}>
              <h5 style={{ color: '#849F76', textTransform: 'uppercase' }}>
                FIRST INSURER CERTIFIED IN 2021
              </h5>
              <p>
                Congratulations to The Wawanesa Mutual Insurance Company—the first insurer to earn CSIO’s Billing eDocs Certification
              </p>
            </div>
          </div>
          <h4 style={{ color: '#1C1F3D', textTransform: 'uppercase', marginTop: 30 }}>
            SEE THE DIFFERENCE FOR YOURSELF
          </h4>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: 30,
            marginBottom: 30
          }}>
            <iframe width={`${videoPlayerWidth}`} height={`${videoPlayerHeight}`} src="https://www.youtube.com/embed/K3rnEg0ZnPU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            {/* <a style={{ marginTop: 30 }} class="headerDownloadPdfLink" href="https://csio.com/solutions-tools/data-standards/edocs/billing-claims-savings-calculator" alt="Go to CSIO.com > Solutions & Tools > eDocs Standard to find the calculator">
              Calculate <em>your</em> potential savings in time and money
            </a> */}
          </div>

          <blockquote>
          “Implementing the Billing eDocs solution is an exciting step toward improving a customer’s journey within insurance. This solution will bring significant efficiencies and an overall better experience for our customers.”
            <span>Vicky Todd, Director, Premium Accounting at Northbridge Insurance
            <br />
            INNOTECH Billing Working Group Participant</span>
          </blockquote>

          <blockquote>
          “CSIO has shown how collaboration with insurers, brokers and vendors can streamline pertinent information in a concise and logical manner. Having a solution that allows accurate, up-to-date claims status information to be accessed by a broker from their BMS is a celebrated step forward.”
            <span>Rose Cavaliere, Operations Manager at Dawson & Keenan Insurance Ltd.
            <br />
            INNOTECH Claims Working Group Participant</span>
          </blockquote>

          {/* <div style={{
            fontSize: 18,
            fontWeight: '600',
            margin: 60,
            marginTop: 60,
            marginBottom: 10
          }}>
            “Implementing the Billing eDocs solution is an exciting step toward improving a customer’s journey within insurance. This solution will bring significant efficiencies and an overall better experience for our customers.”
          </div>
          <div style={{ color: '#48604C', fontWeight: '600', marginLeft: 60, marginRight: 60 }}>
            - Vicky Todd, Director, Premium Accounting at Northbridge Insurance
            <br />
            INNOTECH Billing Working Group Participant
          </div> */}
          {/* <div style={{
            fontSize: 18,
            fontWeight: '600',
            margin: 60,
            marginBottom: 10,
            marginTop: 30
          }}>
            “CSIO has shown how collaboration with insurers, brokers and vendors can streamline pertinent information in a concise and logical manner. Having a solution that allows accurate, up-to-date claims status information to be accessed by a broker from their BMS is a celebrated step forward.”
          </div>
          <div style={{ color: '#48604C', fontWeight: '600', marginLeft: 60, marginRight: 60 }}>
            - Rose Cavaliere, Operations Manager at Dawson & Keenan Insurance Ltd.
            <br />
            INNOTECH Claims Working Group Participant
          </div> */}
          <h3 style={{ marginTop: 60, textAlign: 'center' }} id="innotech-advisory-committee" tabIndex="-1">
            INNOTECH Advisory Committee
          </h3>
          <p style={{
            marginTop: 30
          }}>
            Thanks to the <a href="https://csio.com/solutions-tools/innotech-committee/members" alt="CSIO.com's innotech committee members webpage">INNOTECH Advisory Committee</a> and <a href="https://csio.com/solutions-tools/innotech-committee/working-group" alt="CSIO.com's billing and claims working group webpage">Billing & Claims Working Group</a> members for
            your time and commitment towards finding solutions to resolve our industry’s pain points.
          </p>

          {/* <AdvisoryCommittee /> */}

          <h3 style={{ marginTop: 60, textAlign: 'center' }} id="commercial-lines-data-standards" tabIndex="-1">
            COMMERCIAL LINES (CL) DATA STANDARDS
          </h3>

          <p style={{
            marginTop: 30
          }}>
            In just four years, CSIO CL Data Standards have taken the commercial quote process from
            cumbersome to consensus, through a series of robust, mature Standards that members use every
            single day.
          </p>
          <p>
            Brokers no longer have to submit quotes for small commercial business in varying portals, or through
            emails or PDF files. CL Data Standards mean fast, efficient processes that deliver commercial quotes
            in minutes, not days.
          </p>
          <h4 style={{ color: '#48604C', textTransform: 'uppercase', marginTop: 60, marginBottom: 60 }}>
            The industry needs–and wants–CL Data Standards
          </h4>

          <CLDataStandardsHighlights />

          <p>
            The Commercial Lines Working Group has defined the common data (set of questions) and
            smoothed the data exchange to set brokers up for success with commercial clients in four
            underserved sectors:
          </p>
          <Container>
            <Row>
              <Col>
                <ul>
                  <li>
                    Contractors
                  </li>
                  <li>
                    Retailers
                  </li>
                </ul>
              </Col>
              <Col>
                <ul>
                  <li>
                    Business and professional services
                  </li>
                  <li>
                    Multi-operations small business—<span style={{
                      fontFamily: 'montserrat bold',
                      fontWeight: 'bold',
                      color: '#1B526D',
                    }}>NEW in 2021</span>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
          <h5 style={{ color: '#1C1F3D', textTransform: 'uppercase', marginTop: 30 }}>
            THE ROAD TO ROBUST DATA STANDARDS
          </h5>
          <img
            src={theRoadToRobustDataStandards}
            width="100%"
            height="auto"
            alt="A roadmap of events CSIO has taken toward robust Standards. 2017, CSIO commissions Conference Board of Canada study. July 2018, CL Working Group forms. Nov. 2018, Minimum data set for all commercial risks available. June 2020, Faster data exchange for small retailers, as minimum data set launches. Nov. 2019, Standard questions for underwriting small contractors available. May 2020, CL certification program launches. June 2020, Brokercore achieves Level II certification. June 2020, Faster data exchange for small retailers, as minimum data set launches. Dec. 2020, Minimum data set for all 80 small business and professional IBC codes releases. Apr. 2021, Unica and Vertafore complete all three certification levels. June 2021, Multi-operations small business quote requests available. Dec. 2021, Multi-operations small business binding available."
            style={{
              marginTop: 30
            }}
          />

          <h5 style={{ color: '#849F76', marginTop: 60 }}>
            Supporting the Solution
          </h5>
          <p>
            The CL Data Standards Certification Program supports insurers and vendors in implementing the
            CL Data Standards. Certification provides certainty that the CL Data Standards are in place and
            delivering results.
          </p>

          <h5 style={{ color: '#849F76', textTransform: 'uppercase', marginTop: 60 }}>
            Reaching new levels in certification
          </h5>
          <p>
            Congratulations to
            Unica Insurance and Vertafore, the first insurer
            and vendor to complete
            all three levels of the
            CL Certification Program.
          </p>
          <h5 style={{ color: '#1C1F3D', textTransform: 'uppercase', marginTop: 60 }}>
            CERTIFIED FOR CERTAINTY
          </h5>
          <p>
            CSIO is pleased to recognize <a href="https://csio.com/solutions-tools/csio-certification/certified-members" alt="CSIO.com's certified members webpage">these certified insurers and vendors</a> as innovative leaders.
          </p>
          {/* <table style={{
            fontFamily: 'montserrat medium',
            width: '100%'
          }}>
            <tr style={{
              // border: '1px solid red',
              backgroundColor: '#00546F',
              color: 'white',
              height: 60
            }}>
              <th></th>
              <th>Level I - Foundation</th>
              <th>Level II - Verified</th>
              <th>Level III - Certified</th>
            </tr>
            <tr>
              <td style={{
                fontFamily: 'montserrat bold',
              }}>INSURER</td>
              <td style={{ paddingTop: 30 }}>
                Northbridge Insurance<br />
                RSA Canada<br />
                Travelers Canada<br />
                Unica Insurance<br />
                The Wawanesa Mutual<br />
                Insurance Company
              </td>
              <td style={{ paddingTop: 30 }}>
                Northbridge Insurance<br />
                Unica Insurance
              </td>
              <td style={{ paddingTop: 30 }}>
                Unica Insurance
              </td>
            </tr>
            <tr>
              <td style={{
                fontFamily: 'montserrat bold',
              }}>VENDOR</td>
              <td style={{ paddingTop: 30 }}>
                Applied Systems Inc.<br />
                Brokercore<br />
                Vertafore Canada
              </td>
              <td style={{ paddingTop: 30 }}>
                Applied Systems Inc.<br />
                Brokercore<br />
                Vertafore Canada
              </td>
              <td style={{ paddingTop: 30 }}>Vertafore Canada</td>
            </tr>
          </table> */}

          <h4 style={{ color: '#1C1F3D', textTransform: 'uppercase', marginTop: 60 }}>
            FIND OUT FOR YOURSELF
          </h4>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: 30,
            marginBottom: 30
          }}>
            <iframe width={`${videoPlayerWidth}`} height={`${videoPlayerHeight}`} src="https://www.youtube.com/embed/Gi6CiL1G2Gs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>

          <p style={{ marginTop: 30 }}>
            Our thanks to the insurers, vendors and IBAC representatives that make up the Commercial Lines Working Group. They meet regularly to set the standard for real-time commercial quoting. A list of Working Group members can be found <a href={CSIO_2021_Annual_Report_CL_Working_Groups} alt="Page 23 of the annual review pdf" style={{ fontWeight: 'bold' }}><strong>here</strong></a>.
          </p>

          {/* <div style={{
            fontSize: 18,
            // padding: 72, 
            // paddingTop: 32, 
            // textAlign: 'center', 
            fontWeight: '600',
            margin: 60,
            marginBottom: 10,
            marginTop: 30
          }}>
            “I’m extremely proud of the contributions that Travelers Canada and every other CL Working Group member has made to advancing CL Data Standards over the last few years. The diversity of representation by insurers and vendors on the Working Group ensures we're meeting the needs of our entire industry—with the ultimate winner being our customers.”
          </div>
          <div style={{ color: '#48604C', fontWeight: '600', marginLeft: 60, marginRight: 60, marginBottom: 30 }}>
            - Laura McDonald, AVP Customer Experience, Business Insurance at Travelers Canada
          </div> */}

          <blockquote>
          “I’m extremely proud of the contributions that Travelers Canada and every other CL Working Group member has made to advancing CL Data Standards over the last few years. The diversity of representation by insurers and vendors on the Working Group ensures we're meeting the needs of our entire industry—with the ultimate winner being our customers.”
            <span>Laura McDonald, AVP Customer Experience,<br/>Business Insurance at Travelers Canada</span>
          </blockquote>

          <h3 style={{ marginTop: 60, textAlign: 'center' }} id="csio-data-standards" tabIndex="-1">
            CSIO DATA STANDARDS
          </h3>

          <p style={{
            marginTop: 30
          }}>
            Modern, evolving Data Standards make the difference to our members’ ease of doing business.
            Smoothing the path through Data Standards is at the heart of everything we do.
          </p>

          <DataStandardsHighlights />

          <p style={{
            marginTop: 30
          }}>
            CSIO Data Standards provide a common language, so the industry’s different platforms keep
            communicating. Achieving consensus, then applying the Standards, means that data moves
            seamlessly between insurers and brokers, with less manual intervention and fewer friction points.
          </p>

          <h5 style={{ color: '#849F76' }}>
            Living Standards evolve for new needs
          </h5>
          <p style={{
          }}>
            Updating and refreshing the EDI and XML Data Standards monthly keep them in sync with business
            needs. The National Standards Working Group ensures that since product evolution doesn’t stop
            neither does the evolution of these Standards.
          </p>

          <p style={{ marginTop: 30 }}>
            A list of Working Group members can be found <a href={CSIO_2021_Annual_Report_National_Standards_working_group} alt="Page 25 of the annual review pdf" style={{ fontWeight: 'bold' }}><strong>here</strong></a>.
          </p>



          { /* */}


        </Col>
      </Row>
      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH} />
    </PageWrapper>
  )
}

export default InnovationPage;
